<!-- #BR#105 - Mbeng - new analysis page - 28/07/2025 -->
<template>
    <div class="analysis">
      <!-- Header Section -->
      <Header class="responsive-bar">
        <template v-slot:title>
          {{ $t("Analysis") }}
        </template>
      </Header>
  
      <!-- <div class="bg-gray-50 shadow rounded-md min-h-screen max-w-3xl m-auto sm:mt-5 py-10 px-6"> -->
      <div class="m-5">
  
        <tabs class="tab mt-4" v-model="activeTab"  :options="{ useUrlFragment: false }">
        
        <!-- BR#160 - 13/02/2026 - Removed market-buzz tab - Mbeng -->
        <!-- Market buzz Tab -->
        <!-- <tab :name="$t('market-buzz')"  :title="$t('market-buzz')" id="market-buzz" value="market-buzz">
          
            <div class="relative w-full" style="height:1300px;">
                
                <iframe
                :src="url2"
                allowtransparency="true"
                frameborder="0"
                class="w-full h-full relative z-0"
                style="border:0; clip-path: inset(50px 0 0 0);"
                ></iframe>

                
                 <div class="absolute top-0 left-0 w-full h-[50px] bg-white z-10 pointer-events-none"></div>
               
            </div>
        </tab> -->

        <!-- Economic insight Tab -->
        <tab :name="$t('economic-insight')" :title="$t('economic-insight')" id="economic-insight" value="economic-insight">
          
            <div class="relative w-full" style="height:1300px;">
                <!-- Iframe -->
                <iframe
                :src="url1"
                allowtransparency="true"
                frameborder="0"
                class="w-full h-full relative z-0"
                style="border:0; clip-path: inset(50px 0 0 0);"
                ></iframe>

                <!-- Overlay -->
                 <div class="absolute top-0 left-0 w-full h-[50px] bg-white z-10 pointer-events-none"></div>
                <!-- <div
                class="absolute top-0 left-0 w-full"
                style="height:60px; background:white; z-index:9999;"
                ></div> -->
            </div>
        </tab>

        <!-- Analyst views Tab -->
        <tab :name="$t('analyst-views')" :title="$t('analyst-views')" id="analyst-views" value="analyst-views">
            
           <div class="relative w-full" style="height:1300px;">
                <!-- Iframe -->
                <iframe
                :src="url"
                allowtransparency="true"
                frameborder="0"
                class="w-full h-full relative z-0"
                style="border:0; clip-path: inset(50px 0 0 0);"
                ></iframe>

                <!-- Overlay -->
                <div class="absolute top-0 left-0 w-full h-[50px] bg-white z-10 pointer-events-none"></div>
                <!-- <div
                class="absolute top-0 left-0 w-full"
                style="height:60px; background:white; z-index:9999;"
                ></div> -->
            </div>
        </tab>

        <!-- Education on demands Tab -->
        <tab :name="$t('education-on-demand')" :title="$t('education-on-demand')" id="education-on-demand" value="education-on-demand">
           
            <div class="relative w-full" style="height:1300px;">
                <!-- Iframe -->
                <iframe
                :src="url3"
                allowtransparency="true"
                frameborder="0"
                class="w-full h-full relative z-0"
                style="border:0; clip-path: inset(50px 0 0 0);"
                ></iframe>

                <!-- Overlay -->
                <div class="absolute top-0 left-0 w-full h-[50px] bg-white z-10 pointer-events-none"></div>
                <!-- <div
                class="absolute top-0 left-0 w-full"
                style="height:60px; background:white; z-index:9999;"
                ></div> -->
            </div>
        </tab>
      </tabs>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Header from "@/components/Header";
import { Tabs, Tab } from 'vue-tabs-component';
import Vue from "vue";
import VueI18Next from "@panter/vue-i18next";
import i18next from "i18next";
import { nextTick } from 'vue';


Vue.use(VueI18Next);
const i18n = new VueI18Next(i18next);

export default {
  name: "Analysis",
  components: {
    Header,
    Tabs,
    Tab,
  },
  data() {
    return {
      url: "",
      url1:"",
      url2:"",
      url3:"",
      activeTab: "market-buzz", // default
      whitelabel: process.env.VUE_APP_WHITELABEL,
    };
  },

  computed: {
    ...mapGetters(["get_profile", "get_uploaded_documents"]),
    lang() {
      let language = this.$store.getters.get_lang;
      if (language === "zh-Hant") {
        language = "zh-hant";
      }
      if (language === "zh-Hans") {
        language = "zh-hans";
      }
      return language;
    },
  },
  mounted() {
   
    // const hash = this.$route.hash.replace("#", "");
    // if (["market-buzz", "economic-insight","analyst-views","education-on-demand"].includes(hash)) {
    //     this.activeTab = hash;
    // } else {
    //     this.activeTab = "market-buzz"; // Default tab
    // };

    // this.setTabFromHash(this.$route.hash);
    this.activeTab = "market-buzz";
       
  },
  watch: {
    activeTab(newVal) {
        // if (this.$route.hash !== `#${newVal}`) {
        // this.$router.replace({ hash: `#${newVal}` });
        // }
    },

    // '$route.hash'(newHash) {
    //     //this.setTabFromHash(newHash);
    // },

     lang() {
      this.getUrl();
      this.getUrl1();
      this.getUrl2();
      this.getUrl3();
    },
  },
  created() {
    this.getUrl();
    this.getUrl1();
    this.getUrl2();
    this.getUrl3();
  },
  methods: {
   getUrl() {
      this.$store.dispatch("analysis_url", this.lang).then((resp) => {
        this.url = resp.data.url;
      });
    },

   getUrl2() {
      this.$store.dispatch("analysis_market_buzz_url", this.lang).then((resp) => {
        this.url2 = resp.data.url;
      });
    },


   getUrl3() {
      this.$store.dispatch("analysis_education_on_demand_url", this.lang).then((resp) => {
        this.url3 = resp.data.url;
      });
    },


   getUrl1() {
      this.$store.dispatch("analysis_economic_insight_url", this.lang).then((resp) => {
        this.url1 = resp.data.url;
      });
    },

    // setTabFromHash(hash) {
    //     if (hash === '#market-buzz') {
    //     this.activeTab = 'market-buzz';
    //     } else if (hash === '#economic-insight') {
    //     this.activeTab = 'economic-insight';
    //     } else if (hash === '#analyst-views') {
    //     this.activeTab = 'analyst-views';
    //     } else if (hash === '#education-on-demand') {
    //     this.activeTab = 'education-on-demand';
    //     } else {
    //     this.activeTab = 'market-buzz'; 
    //     }
    // },
   
  }
};
</script>
  
<style>
.tabs-component {
  margin-bottom: 1.5rem;
}

/* Container holding the tabs */
.tabs-component-tabs {
  display: flex;              /* make them horizontal */
  flex-direction: row;
  background: #f9f9f9;
  border-bottom: 2px solid #ddd;
  padding: 0;
  margin: 0;
}

/* Each tab */
.tabs-component-tab {
  list-style: none;
  padding: 10px 20px;
  cursor: pointer;
  border: none;
  background: transparent;
  color: #333;
  font-weight: 500;
  transition: all 0.3s ease;
  border-radius: 6px 6px 0 0; /* rounded top corners */
  margin-right: 5px;
}

/* Hover effect */
.tabs-component-tab:hover {
  background: #eaeaea;
  color: #0d4778; /*BR#131 - Mbeng - 12/11/2025 - Analysis' tab  align brand colour to #0d4778 */
}

/* Active tab */
.tabs-component-tab.is-active {
  background: #0d4778; /* blue */ /*BR#131 - Mbeng - 12/11/2025 - Analysis' tab  align brand colour to #0d4778 */
  color: #fff;
  border-bottom: none;
}


.tabs {
  font-family: Arial, sans-serif;
}

.tab-headers {
  display: flex; 
  gap: 10px;
  margin-bottom: 10px;
}

.tab-headers button {
  padding: 10px 20px;
  border: none;
  background-color: #f0f0f0;
  cursor: pointer;
  transition: background-color 0.3s;
}

.tab-headers button.active {
  background-color: #0d4778; /*BR#131 - Mbeng - 12/11/2025 - Analysis' tab  align brand colour to #0d4778 */
  color: white;
}

.tab-content {
  padding: 10px;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
}
</style>


